<template>
  <el-footer>
    Footer
  </el-footer>
</template>
<script>
  export default {

  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ContentFooter.vue